exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.my[data-v-4b85d3ee] {\n  margin-top: 4px;\n  margin-bottom: 4px;\n}\n.mr[data-v-4b85d3ee] {\n  margin-right: 10px;\n}\n.top_notice[data-v-4b85d3ee]{\n  text-align:center;\n  white-space: pre-line;\n}\n", ""]);

// exports
